export default function (nga, admin) {

    let menu = nga.menu();

    menu.addChild(nga.menu()
        .title('ACCOUNT')
        .icon('<i class="fa fa-user fa-fw"></i>')
        .link('/account')
        .active(function(path) {
            return path.indexOf('/account') !== -1 || path.indexOf('/profile') !== -1;
        })
    );


    let purchases = nga.menu()
        .title('PURCHASES')
        .icon('<i class="fa fa-shopping-cart fa-fw"></i>')
        .link('/purchases/')
        .active(function(path) {
            return path.indexOf('/purchases') !== -1;
        });

    if(HasRole(['admin', 'superadmin'])) {
        if(GetData().currentUser && !GetData().currentUser.company){
            menu.addChild(purchases);
        }

    }

    menu.addChild(nga.menu()
        .title('DOWNLOADS')
        .icon('<i class="fa fa-cloud-download fa-fw"></i>')
        .link('/downloads')
        .active(function(path) {
            return path.indexOf('/downloads') !== -1;
        })
    );


    if(HasRole(['superadmin', 'company', 'prenscriptor'])) {

        let user = nga.menu(admin.getEntity('user'))
            .title('USERS')
            .icon('<i class="fa fa-users fa-fw"></i>')
            .active(function(path) {
                return path.indexOf('/user') !== -1;
            });

        if(HasRole(['admin', 'superadmin'])){
            user.addChild(nga.menu(admin.getEntity('user'))
                .title('USER_LIST')
                .icon('<i class="fa fa-list fa-fw"></i>')
                .active(function(path) {
                    return path.indexOf('/user') !== -1;
                })
            );

            user.addChild(nga.menu(admin.getEntity('prenscriptor'))
                .title('PRENSCRIBER_LIST')
                .icon('<i class="fa fa-list fa-fw"></i>')
                .active(function(path) {
                    return path.indexOf('/prenscriptor') !== -1;
                })
            );

            user.addChild(nga.menu(admin.getEntity('company'))
                .title('COMPANY_LIST')
                .icon('<i class="fa fa-list fa-fw"></i>')
                .active(function(path) {
                    return path.indexOf('/compnay') !== -1;
                })
            );

            user.addChild(nga.menu(admin.getEntity('prescriberType'))
                .title('PRESCRIBER_TYPES')
                .icon('<i class="fa fa-graduation-cap fa-fw"></i>')
                .active(function(path) {
                    return path.indexOf('/prescriberType') !== -1;
                })
            );

            purchases.addChild(nga.menu(admin.getEntity('promo'))
                .title('PROMOS')
                .icon('<i class="fa fa-list fa-fw"></i>')
                .active(function(path) {
                    return path.indexOf('/promo') !== -1;
                })
            );

            purchases.addChild(nga.menu(admin.getEntity('purchase'))
                .title('ORDERS')
                .icon('<i class="fa fa-list fa-fw"></i>')
                .active(function(path) {
                    return path.indexOf('/purchase') !== -1;
                })
            );
            purchases.addChild(nga.menu(admin.getEntity('licence'))
                .title('LICENCES')
                .icon('<i class="fa fa-list fa-fw"></i>')
                .active(function(path) {
                    return path.indexOf('/licence/') !== -1;
                })
            );
            purchases.addChild(nga.menu(admin.getEntity('licencetype'))
                .title('LICENCES_TYPE')
                .icon('<i class="fa fa-list fa-fw"></i>')
                .active(function(path) {
                    return path.indexOf('/licencetype/') !== -1;
                })
            );
            purchases.addChild(nga.menu(admin.getEntity('gamevrlicence'))
                .title('LICENCES_GAME_VR')
                .icon('<i class="fa fa-list fa-fw"></i>')
                .active(function(path) {
                    return path.indexOf('/gamevrlicence') !== -1;
                })
            );
            purchases.addChild(nga.menu(admin.getEntity('subscription'))
                .title('SUBSCRIPTIONS')
                .icon('<i class="fa fa-list fa-fw"></i>')
                .active(function(path) {
                    return path.indexOf('/subscription') !== -1;
                })
            );
            purchases.addChild(nga.menu(admin.getEntity('product'))
                .title('PRODUCTS')
                .icon('<i class="fa fa-list fa-fw"></i>')
                .active(function(path) {
                    return path.indexOf('/product') !== -1;
                })
            );
            purchases.addChild(nga.menu(admin.getEntity('invoice'))
                .title('INVOICES')
                .icon('<i class="fa fa-list fa-fw"></i>')
                .active(function(path) {
                    return path.indexOf('/invoice') !== -1;
                })
            );
            purchases.addChild(nga.menu(admin.getEntity('payment'))
                .title('PAYMENTS')
                .icon('<i class="fa fa-list fa-fw"></i>')
                .active(function(path) {
                    return path.indexOf('/payment') !== -1;
                })
            );

         };

         menu.addChild(user);
    }

    if(HasRole(['company']) && !HasRole(['superadmin'])) {
        menu.addChild(nga.menu(admin.getEntity('prenscriptor'))
            .title('PRESNCRIPTORS')
            .icon('<i class="fa fa-users fa-fw"></i>')
            .active(function(path) {
                return path.indexOf('/prenscriptor') !== -1;
            })
        );
    }

    if(HasRole('admin')){
        let games = nga.menu(admin.getEntity('game'))
            .title('GAMES')
            .icon('<i class="fa fa-gamepad fa-fw"></i>')
            .active(function(path) {
                return path.indexOf('/game') !== -1;
            });
        menu.addChild(games);


        games.addChild(nga.menu(admin.getEntity('competence'))
            .title('COMPETENCES')
            .icon('<i class="fa fa-object-group fa-fw"></i>')
            .active(function(path) {
                return path.indexOf('/competence') !== -1;
            })
        );

        games.addChild(nga.menu(admin.getEntity('ability'))
            .title('ABILITIES')
            .icon('<i class="fa fa-puzzle-piece fa-fw"></i>')
            .active(function(path) {
                return path.indexOf('/ability') !== -1;
            })
        );

        games.addChild(nga.menu(admin.getEntity('game'))
            .title('PROCEDURES')
            .icon('<i class="fa fa-gamepad fa-fw"></i>')
            .active(function(path) {
                return path.indexOf('/game/') !== -1;
            })
        );

        games.addChild(nga.menu(admin.getEntity('gamevr'))
            .title('VR')
            .icon('<i class="fa fa-eye fa-fw"></i>')
            .active(function(path) {
                return path.indexOf('/gamevr') !== -1;
            })
        );

        games.addChild(nga.menu(admin.getEntity('variable'))
                .title('VARIABLES')
                .icon('<i class="fa fa-cog fa-fw"></i>')
                .active(function(path) {
                    return path.indexOf('/variable') !== -1;
                })
            );

        menu.addChild(nga.menu(admin.getEntity('event'))
            .title('EVENTS')
            .icon('<i class="fa fa-calendar fa-fw"></i>'))
            .active(function(path) {
                return path.indexOf('/event') !== -1;
            });
    }

    if(HasRole(['superadmin'])) {
        menu.addChild(nga.menu()
            .title('CONFIG')
            .icon('<i class="fa fa-cog fa-fw"></i>')
            .link('/options')
            .active(function (path) {
                return path.indexOf('/options') !== -1;
            })
        );
    }

    if(HasRole(['company', 'prenscriptor']) && !HasRole(['superadmin'])) {
        menu.addChild(nga.menu()
            .title('PROFESSIONAL_MANUAL')
            .icon('<i class="fa fa-book fa-fw"></i>')
            .link('PROFESSIONAL_MANUAL_LINK')
        );
    }


    if(HasRole(['patient']) && !HasRole(['superadmin'])) {
        menu.addChild(nga.menu()
            .title('USER_MANUAL')
            .icon('<i class="fa fa-book fa-fw"></i>')
            .link('USER_MANUAL_LINK')
        );
    }


    return menu;
}



/** WEBPACK FOOTER **
 ** ./js/menu.js
 **/